export default __webpack_public_path__ + "postMock-1752492144082.html";